import audioService from '../services/AudioService';
import {setBoxChampState, setScanPackBarcodeInput} from './scanpackScanningSetters';
import {
  getGuidedView,
  boxChampOf,
  isGuidedOrderAwaitingLastSeal
} from '../components/ScanpackScanning/utils/boxChampGuidedSelectors';

export const BOX_CHAMP_MANUAL_NAV_MESSAGE =
  "Manual box navigation isn't available on a planned order — seal or confirm the current box, or scan its barcode, to move between boxes.";
export const BOX_CHAMP_SCAN_ALL_MESSAGE =
  'Scan-all is not available on a planned order — pack it box by box';
export const BOX_CHAMP_RESTART_AFTER_PACKED_MESSAGE =
  "Every item is packed — the order can't be restarted now. Confirm the last box to finish it.";
const CONFIRMATION_MS = 2500;

let confirmationTimer = null;

export const clearBoxChampConfirmationTimer = () => {
  clearTimeout(confirmationTimer);
  confirmationTimer = null;
};

export function showBoxChampConfirmation(message, extra = {}) {
  return (dispatch, getState) => {
    clearBoxChampConfirmationTimer();
    dispatch(
      setBoxChampState({
        ...extra,
        setAsideMessage: message,
        setAsideConfirmation: true,
        handoffDismissedKey: null
      })
    );
    confirmationTimer = setTimeout(() => {
      confirmationTimer = null;
      const guided = boxChampOf(getState());
      if (guided.setAsideConfirmation && guided.setAsideMessage === message) {
        dispatch(setBoxChampState({setAsideMessage: '', setAsideConfirmation: false}));
      }
    }, CONFIRMATION_MS);
  };
}

export const showSetAsideMessage = (dispatch, message) => {
  clearBoxChampConfirmationTimer();
  dispatch(
    setBoxChampState({
      setAsideMessage: message,
      setAsideConfirmation: false,
      handoffDismissedKey: null
    })
  );
};

export const setItemAside = (dispatch, message) => {
  audioService.playSetAsideSound();
  dispatch(setScanPackBarcodeInput(''));
  showSetAsideMessage(dispatch, message);
};

export function refuseManualBoxNavigation() {
  return (dispatch, getState) => {
    if (!getGuidedView(getState())) return false;
    setItemAside(dispatch, BOX_CHAMP_MANUAL_NAV_MESSAGE);
    return true;
  };
}

export function refuseRestartAwaitingLastSeal() {
  return (dispatch, getState) => {
    if (!isGuidedOrderAwaitingLastSeal(getState())) return false;
    setItemAside(dispatch, BOX_CHAMP_RESTART_AFTER_PACKED_MESSAGE);
    return true;
  };
}
